import script from "./KAMForms.vue?vue&type=script&lang=ts&setup=true"
export * from "./KAMForms.vue?vue&type=script&lang=ts&setup=true"

import "./KAMForms.vue?vue&type=style&index=0&id=3955a672&scoped=true&lang=css"
import "./KAMForms.vue?vue&type=style&index=1&id=3955a672&lang=css"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3955a672"]])

export default __exports__